import TaxonomyCreateForm from './taxonomy-create-form'

export default TaxonomyCreateForm;